<template>
  <div style="height: 100%" class="door_sensor">
    <div class="vx-row" style="height: 100%">
      <vs-tabs>
        <vs-tab label="Main">
          <div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <label for="" class="vs-input--label">Component source</label>

                <v-select v-model="reader_data.component_source" :options="componentSources"
                  class="select_padding w-full" name="status" @input="changeComponentSource"
                  placeholder="Component source" :reduce="(source) => source.id" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :selectable="(option) => !option.disabled" />
              </div>

              <div class="vx-col w-1/2 mt-3">
                <label for="" class="vs-input--label">Condition</label>

                <v-select v-model="condition_item" :options="conditions" class="select_padding w-full" name="status"
                  placeholder="Condition" :reduce="(source) => source.id"
                  @input="(event) => changeConditionSource(event)" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              </div>

              <div class="vx-col w-1/2 mt-3">
                <label for="" class="vs-input--label">Inputs</label>

                <v-select v-model="reader_data.input" :options="inputs" class="select_padding w-full" name="status"
                  placeholder="Inputs" :reduce="(source) => source.id" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  @input="(event) => changeInputSource(event)" :disabled="reader_data.component_source == null"
                  :selectable="(option) => !option.disabled" />
              </div>

              <div class="vx-col w-full mt-3">
                <vs-input label="Name" class="w-full" name="name" disabled v-model="reader_data.name" />
              </div>
            </div>
          </div>
        </vs-tab>


      </vs-tabs>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { checkInputArr } from "@/functions/checkInputOutput";
export default {
  data() {
    return {
      condition_item: "",
      reader_data: {},
      inputs: [],
      componentSources: [],
    };
  },
  watch: {
    acuModel() {
      this.setInputs();

      this.componentSources = [
        { id: 0, label: "ACU", disabled: this.isFloor ? true : false },
      ];
      if (this.extDevice.length) {
        this.extDevice.forEach((device) => {
          let hasInput = {};
          if (device.ext_board == "AIR-R") {
            hasInput = this.expansion_boards.reader_board["AIR-R"];
          } else if (device.ext_board == "REX-16") {
            hasInput = this.expansion_boards.relay_board["REX-16"];
          } else if (device.ext_board == "IEX-16") {
            hasInput = this.expansion_boards.alarm_board["IEX-16"];
          }

          if (hasInput.inputs) {
            this.componentSources.push({ id: device.id, label: device.name });
          }
        });
      }
    },
    reader_data: {
      handler: function (reader_data) {
        this.$store.commit("accessPoint/SET_EDIT_READER_DATA", {
          data: { ...reader_data },
        });
      },
      deep: true,
    },
    active_reader(data) {
      this.componentSources = [
        { id: 0, label: "ACU", disabled: this.isFloor ? true : false },
      ];
      if (this.extDevice.length) {
        this.extDevice.forEach((device) => {
          let hasInput = {};
          if (device.ext_board == "AIR-R") {
            hasInput = this.expansion_boards.reader_board["AIR-R"];
          } else if (device.ext_board == "REX-16") {
            hasInput = this.expansion_boards.relay_board["REX-16"];
          } else if (device.ext_board == "IEX-16") {
            hasInput = this.expansion_boards.alarm_board["IEX-16"];
          }

          if (hasInput.inputs) {
            this.componentSources.push({ id: device.id, label: device.name });
          }
        });
      }
      let access_point;
      let reader;
      if (!this.active_point) {
        reader = JSON.parse(
          JSON.stringify(this.$store.state.accessPoint.edit_acu_data.readers)
        );
      } else if (Number.isInteger(+this.active_point)) {
        access_point = this.access_points.find(
          (a) => a.id == +this.active_point
        );
        const split = data.split("-", 2);

        if (this.res_types[split[1]]) {
          reader = { ...access_point.resources[split[1]] };
        } else if (access_point.new_readers && access_point.new_readers[data]) {
          reader = { ...access_point.new_readers[data] };
        } else {
          return;
        }
      } else {
        access_point =
          this.$store.state.accessPoint.edit_acu_data.new_access_points[
          this.active_point
          ];
        reader = { ...access_point.readers[data] };
      }

      if (!reader.data) {
        this.reader_data = { ...reader, name: reader.name };
      } else if (reader.reader_info) {
        this.reader_data = {
          ...reader.reader_info,
          name: reader.reader_info.data.device,
        };
      } else if (reader.data && !reader.reader_info) {
        this.reader_data = {
          ...reader,
          name: reader.data.device,
        };
      }
      this.setInputs();
    },
  },
  computed: {
    selectedPortList() {
      return this.$store.state.accessPoint.edit_acu_data.selectedPorts;
    },
    active_reader() {
      return this.$store.state.accessPoint.edit_active_reader;
    },
    active_point() {
      return this.$store.state.accessPoint.edit_active_point;
    },
    access_points() {
      return this.$store.state.accessPoint.edit_acu_data.access_points;
    },
    conditions() {
      return this.$store.state.accessPoint.conditions;
    },
    res_types() {
      return this.$store.state.accessPoint.res_types;
    },
    acuModel() {
      return this.$store.state.accessPoint.edit_acu_data.model;
    },
    acu_model() {
      return this.$store.state.accessPoint.acu_model.controllers;
    },
    extDevice() {
      return this.$store.state.accessPoint.edit_acu_data.ext_devices;
    },
    expansion_boards() {
      return this.$store.state.accessPoint.acu_model.expansion_boards;
    },
    isFloor() {
      let model = this.acuModel;
      let elevator_mode =
        this.$store.state.accessPoint.edit_acu_data.elevator_mode;

      if ((model == "Icon" || model == "Icon-PRO") && elevator_mode) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    checkNumber(value, field) {
      return (this.reader_data[field] = +value.replace(/[^+0-9]/g, ""));
    },
    changeConditionSource(value) {
      this.reader_data = {
        ...this.reader_data,
        condition: value,
      };
      this.condition_item = value;
    },
    changeInputSource(value) {
      this.reader_data.input = value;
      setTimeout(() => {
        this.inputs = this.definedPortOptionList(this.inputs, this.reader_data.component_source)
      }, 400);
    },
    initValues() {
      this.reader_data = {
        component_source: null,
        name: null,
        condition: null,
        input: null,

        enable_door_ajar_alarm: false,
        door_ajar_time: null,
        duration: null,
        trigger_output_if_door_ajar: null,
        enable_door_forced_open_alarm: false,
        trigger_output_if_door_forced_open: null,
      };
    },
    setInputs(changed) {
      const data = this.$store.state.accessPoint.edit_acu_data;
      let input_arr = [];
      const resources = checkInputArr(data, this.active_reader, false);

      if (data.model && !this.reader_data.component_source) {
        if (
          this.acu_model[data.model].inputs_info &&
          !this.reader_data.component_source
        ) {
          const inp_info = this.acu_model[data.model].inputs_info;

          for (const key in inp_info) {
            if (resources.includes(+key)) {
              input_arr.push({
                id: +key,
                label: inp_info[key].name,
                disabled: true,
              });
            } else {
              input_arr.push({ id: +key, label: inp_info[key].name });
            }
          }
          if (changed) {
            this.reader_data.input = input_arr[0].id;
          }
        } else {
          for (let i = 1; i <= this.acu_model[data.model].inputs; i++) {
            if (resources.includes(i)) {
              input_arr.push({ id: i, label: i, disabled: true });
            } else {
              input_arr.push({ id: i, label: i });
            }
          }
          if (changed) {
            this.reader_data.input = input_arr[0].id;
          }
        }

        this.inputs = this.definedPortOptionList(input_arr, this.reader_data.component_source);
      } else {
        this.changeComponentSource();
      }
    },
    changeComponentSource(value) {
      const data = this.$store.state.accessPoint.edit_acu_data;
      const resources = checkInputArr(data, this.active_reader, true);

      if (this.reader_data.component_source !== 0) {
        const dev = this.extDevice.find(
          (i) => i.id === this.reader_data.component_source
        );
        let device;
        let input_arr = [];

        if (dev && dev.ext_board) {
          if (dev.ext_board == "AIR-R") {
            device = this.expansion_boards.reader_board["AIR-R"]
          } else if (dev.ext_board == "REX-16") {
            device = this.expansion_boards.relay_board["REX-16"];
            this.reader_data.relay_mode = dev.relay_mode;
            this.reader_data.impulse_time = dev.impulse_time;
            this.reader_data.entry_exit_open_durations = dev.open_duration;
          } else if (dev.ext_board == "IEX-16") {
            device = this.expansion_boards.alarm_board["IEX-16"];
            const access_point = this.access_points.find((a) => a.id == +this.active_point);

            if ((access_point && access_point.new_readers && !access_point.new_readers[this.active_reader]) || value) {
              this.reader_data.condition = dev.condition;
              this.condition_item = dev.condition;
            }
          }
        }
        if (device.inputs) {
          for (let i = 1; i <= device.inputs; i++) {
            if (resources.includes(i)) {
              input_arr.push({ id: i, label: i, disabled: true });
            } else {
              input_arr.push({ id: i, label: i });
            }
          }
        }
        this.inputs = this.definedPortOptionList(input_arr, this.reader_data.component_source);
      } else {
        this.setInputs();
      }
    },
    fetchSource() {
      this.componentSources = [];
      this.componentSources.push({
        id: 0,
        label: "ACU",
        disabled: this.isFloor ? true : false,
      });
      if (this.extDevice.length) {
        this.extDevice.forEach((device) => {
          let hasInput = {};
          if (device.ext_board == "AIR-R") {
            hasInput = this.expansion_boards.reader_board["AIR-R"];
          } else if (device.ext_board == "REX-16") {
            hasInput = this.expansion_boards.relay_board["REX-16"];
          } else if (device.ext_board == "IEX-16") {
            hasInput = this.expansion_boards.alarm_board["IEX-16"];
          }

          if (hasInput.inputs) {
            this.componentSources.push({ id: device.id, label: device.name });
          }
        });
      }
    },
    definedPortOptionList(portList, source = 0) {
      if (portList.length === 0) return [];
      const selectedPorts = this.selectedPortList;
      return portList.map(item => {
        return { ...item, disabled: !!selectedPorts.input ? !!selectedPorts.input[source]? !!selectedPorts.input[source][`${item.id}`] : false: false }
      })
    },
  },
  created() {
    this.$root.$on("fetchSource", () => {
      this.fetchSource();
    });
    this.componentSources = [];

    this.componentSources.push({
      id: 0,
      label: "ACU",
      disabled: this.isFloor ? true : false,
    });
    if (this.extDevice.length) {
      this.extDevice.forEach((device) => {
        let hasInput = {};
        if (device.ext_board == "AIR-R") {
          hasInput = this.expansion_boards.reader_board["AIR-R"];
        } else if (device.ext_board == "REX-16") {
          hasInput = this.expansion_boards.relay_board["REX-16"];
        } else if (device.ext_board == "IEX-16") {
          hasInput = this.expansion_boards.alarm_board["IEX-16"];
        }

        if (hasInput.inputs) {
          this.componentSources.push({ id: device.id, label: device.name });
        }
      });
    }

    let access_point;
    let reader;

    if (Number.isInteger(+this.active_point)) {
      access_point = this.access_points.find((a) => a.id == +this.active_point);
      const split = this.active_reader.split("-", 2);

      if (this.res_types[split[1]]) {
        reader = { ...access_point.resources[split[1]] };
      } else {
        reader = { ...access_point.new_readers[this.active_reader] };
      }
    } else {
      access_point =
        this.$store.state.accessPoint.edit_acu_data.new_access_points[
        this.active_point
        ];
      reader = { ...access_point.readers[this.active_reader] };
    }

    if (!reader.data) {
      this.reader_data = { ...reader, name: reader.name };
    } else if (reader.reader_info) {
      this.reader_data = {
        ...reader.reader_info,
        name: reader.reader_info.data.device,
      };
    } else if (reader.data && !reader.reader_info) {
      this.reader_data = {
        ...reader,
        name: reader.data.device,
      };
    }
    this.condition_item = this.reader_data.condition;
    this.setInputs();
  },
  components: {
    vSelect,
  },
};
</script>

<style lang="scss">
.door_sensor .con-slot-tabs {
  height: 100%;
}
</style>
